import _ = require('underscore');
import { JispPayMerchantListItem } from '../../app.retailer/modules/core';
import { IStoreJispPay, IStoreJispPayListItem } from '../../app.retailer/modules/jispPay/models';

export abstract class JispPayPlacesBase {
    public waiting = false;
    public places: IStoreJispPayListItem[] = null;
    public jispPayMerchants: JispPayMerchantListItem[] = [];
    public defaultMerchants: JispPayMerchantListItem[] = [];
    public isPlacesAny = null;

    public edit = {
        isOpenEdit: false,
        retailerID: null,
        showRefundPassword: false,
        model: {
            RefundPassword: '',
            JispPayMerchantID: null,
            Enabled: true,
            isPasswordExist: false,
            selectedMerchant: null,
        } as IStoreJispPay,
        error: {
            merchant: null,
            password: null,
            clean: () => {
                const i = this.edit.error;
                i.merchant = null;
                i.password = null;
            },
            isEmpty: () => {
                const i = this.edit.error;
                return _.isEmpty(i.merchant) && _.isEmpty(i.password);
            }
        },
        setModel: (place: IStoreJispPayListItem) => {
            const i = this.edit.model;
            i.JispPayMerchantID = place ? place.JispPayMerchantID : null,
                i.isPasswordExist = place ? place.IsRefundPasswordExist : false;
            i.RefundPassword = place.refundPassword ? place.refundPassword : '';
            i.selectedMerchant = i.JispPayMerchantID ? _.find(this.jispPayMerchants, (merchant) => {
                return merchant.ID === i.JispPayMerchantID;
            }) : null;
            this.edit.error.clean();
        }
    };

    constructor(
        protected $translate: angular.translate.ITranslateService,
    ) { }

    public  placeEdit = (place: IStoreJispPayListItem, showPassword: boolean,  retailerID: number = null) => {
        place.isOpenEdit = true;
        this.edit.isOpenEdit = true;
        this.edit.showRefundPassword = showPassword;
        this.edit.retailerID = retailerID;
        this.edit.setModel(place);
        if (this.edit.showRefundPassword) {
            this.edit.model.isPasswordExist = false;
        }
    }

    public  cancelEdit = (place: IStoreJispPayListItem) => {
        place.isOpenEdit = false;
        this.edit.isOpenEdit = false;
        this.edit.setModel(place);
        if (!place.IsRefundPasswordExist) {
            place.Enabled = false;
        }
    }

    protected isValidEditModel(place: IStoreJispPayListItem) {
        const required = this.$translate.instant('field_is_required');
        const i = this.edit;
        i.error.clean();
        // merchant
        if (!_.isNumber(i.model.JispPayMerchantID)) {
            i.error.merchant = required;
        }
        // password
        i.model.RefundPassword = this.trim(i.model.RefundPassword);
        const size = _.size(i.model.RefundPassword);
        if (!place.IsRefundPasswordExist && size === 0) {
            i.error.password = required;
        } else if (size > 0 && size < 8) {
            i.error.password = this.$translate.instant('password_too_short_8');
        } else if (size > 20) {
            i.error.password = this.$translate.instant('password_too_long_20');
        }
        return i.error.isEmpty();
    }

    private trim(str: string) {
        return str ? str.trim() : '';
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/controllers/jispPayPlacesBase.controller.ts